export class SupportedProviders {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "onboarding",
            "baseName": "onboarding",
            "type": "Array<Provider>",
            "format": ""
        },
        {
            "name": "onboarded",
            "baseName": "onboarded",
            "type": "Array<Provider>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SupportedProviders.attributeTypeMap;
    }
    constructor() {
    }
}
